// src/pages/Shop.jsx
import React from 'react';
import styles from './Shop.module.css';
import ProductCard from '../components/ProductCard/ProductCard';
import { useLanguage } from '../context/LanguageContext';

// 导入压缩后的 WebP 产品图片
// Hand Craft Egg Cup
import eggCup1 from '../assets/images/products/Hand Craft Egg Cup/637A1304.webp';
import eggCup2 from '../assets/images/products/Hand Craft Egg Cup/637A1307 (1).webp';
import eggCup3 from '../assets/images/products/Hand Craft Egg Cup/637A1317.webp';

// Cake Stand
import cakeStand1 from '../assets/images/products/Cake Stand up（单个独立售价195/637A1322.webp';
import cakeStand2 from '../assets/images/products/Cake Stand up（单个独立售价195/637A1326.webp';
import cakeStand3 from '../assets/images/products/Cake Stand up（单个独立售价195/637A1328.webp';

// Cork Silver Necklace
import corkNecklace1 from '../assets/images/products/Cork Silver Necklace/637A1259.webp';
import corkNecklace2 from '../assets/images/products/Cork Silver Necklace/637A1261.webp';
import corkNecklace3 from '../assets/images/products/Cork Silver Necklace/637A1264.webp';

// Cork Leather Necklace
import leatherNecklace1 from '../assets/images/products/Cork leather Necklace/637A1341.webp';

// Little Plant Pot 1
import plantPot1_1 from '../assets/images/products/Little PLant pot1/637A1350.webp';
import plantPot1_2 from '../assets/images/products/Little PLant pot1/637A1353.webp';
import plantPot1_3 from '../assets/images/products/Little PLant pot1/637A1355.webp';
import plantPot1_4 from '../assets/images/products/Little PLant pot1/637A1357.webp';

// Little Plant Pot 2
import plantPot2_1 from '../assets/images/products/Little PLant pot2/637A1344.webp';
import plantPot2_2 from '../assets/images/products/Little PLant pot2/637A1348.webp';

// Cork Lapel Pin
import lapelPin1 from '../assets/images/products/Cork Lapel Pin （单个独立售价160/637A1398.webp';
import lapelPin2 from '../assets/images/products/Cork Lapel Pin （单个独立售价160/637A1401.webp';
import lapelPin3 from '../assets/images/products/Cork Lapel Pin （单个独立售价160/637A1421.webp';

// NY Signature
import nySignature1 from '../assets/images/products/NY signature （单个独立售价40/637A1444.webp';
import nySignature2 from '../assets/images/products/NY signature （单个独立售价40/637A1445.webp';
import nySignature3 from '../assets/images/products/NY signature （单个独立售价40/637A1448.webp';

// 产品基础数据（不含翻译文本）
const productData = [
  { id: 1, price: 50, images: [eggCup1, eggCup2, eggCup3], nameKey: 'products.product1Name', descKey: 'products.product1Desc', subKey: 'products.product1Sub' },
  { id: 2, price: 195, images: [cakeStand1, cakeStand2, cakeStand3], nameKey: 'products.product2Name', descKey: 'products.product2Desc', subKey: 'products.product2Sub' },
  { id: 3, price: 120, images: [corkNecklace1, corkNecklace2, corkNecklace3], nameKey: 'products.product3Name', descKey: 'products.product3Desc', subKey: 'products.product3Sub' },
  { id: 4, price: 95, images: [leatherNecklace1], nameKey: 'products.product4Name', descKey: 'products.product4Desc', subKey: 'products.product4Sub' },
  { id: 5, price: 65, images: [plantPot1_1, plantPot1_2, plantPot1_3, plantPot1_4], nameKey: 'products.product5Name', descKey: 'products.product5Desc', subKey: 'products.product5Sub' },
  { id: 6, price: 65, images: [plantPot2_1, plantPot2_2], nameKey: 'products.product6Name', descKey: 'products.product6Desc', subKey: 'products.product6Sub' },
  { id: 7, price: 160, images: [lapelPin1, lapelPin2, lapelPin3], nameKey: 'products.product7Name', descKey: 'products.product7Desc', subKey: 'products.product7Sub' },
  { id: 8, price: 40, images: [nySignature1, nySignature2, nySignature3], nameKey: 'products.product8Name', descKey: 'products.product8Desc', subKey: 'products.product8Sub' },
];

// 导出产品基础数据供其他组件使用
export { productData };

// 用于获取翻译后产品的 hook
export function useProducts() {
  const { t } = useLanguage();

  return productData.map(product => ({
    ...product,
    name: t(product.nameKey),
    description: t(product.descKey),
    subheading: t(product.subKey),
  }));
}

export default function Shop({ setSelectedProduct }) {
  const products = useProducts();

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    window.history.pushState(null, '', `/product?id=${product.id}`);
    window.dispatchEvent(new Event('popstate'));
  };

  return (
    <div className={styles.shopPage}>
      <div className={styles.container}>
        <div className={styles.productGrid}>
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onClick={() => handleProductClick(product)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}